import { useSelector, useDispatch } from "react-redux";
import { searchScreensActions } from "../slice/searchScreensSlice";
import { getSearchScreensState } from "../selectors/getSearchScreensState";
import { SearchScreen } from "../types/selectedScreensTypes";
import { SearchScreensStateSchema } from "../types/selectedScreensTypes";

export const useSelectedSearchScreens = () => {
  const dispatch = useDispatch();
  const { screens } = useSelector((state: SearchScreensStateSchema) => 
    getSearchScreensState(state)
  );

  const addScreen = (screen: SearchScreen) => {
    dispatch(searchScreensActions.addScreen(screen));
  };

  const removeScreen = (id: number) => {
    dispatch(searchScreensActions.removeScreen(id));
  };

  const isSelected = (id: number) => {
    return screens.some((screen) => screen.id === id);
  };

  const clearSelectedScreens = () => {
    dispatch(searchScreensActions.clearSelectedScreens());
  };

  return {
    selectedScreens: screens,
    addScreen,
    removeScreen,
    isSelected,
    clearSelectedScreens,
  };
}; 